import { AxiosError } from "axios";
import { toast } from "react-toastify";

import api from "../api";

type SaveQueueParams = {
  params: {
    company: {
      id: number;
    };
    driver: {
      id: number;
    };
    truck: {
      id: number;
    };
    scheduling: {
      id: number;
    } | null;
  };
  options?: {
    onInit?: () => void;
    onSuccess?: () => void;
    onError?: (error: { status: number; message1: string; message2: string; message3: string }) => void;
    onFinally?: () => void;
  };
};
async function saveQueue(body: SaveQueueParams["params"], options?: SaveQueueParams["options"]) {
  options?.onInit?.();
  try {
    const { data } = await api.post("queue/save", body);
    toast.success("Entrou na fila com sucesso!");
    options?.onSuccess?.();
    return { data, isSuccess: true, isError: false, error: null };
  } catch (err: any) {
    if (!(err instanceof AxiosError)) {
      console.error("Unexpected error:", err);
      toast.error("Erro inesperado ao salvar na fila. Tente novamente.");
      options?.onError?.({ status: 1, message1: "Erro inesperado", message2: "", message3: "" });
      return { data: null, isSuccess: false, isError: true, error: null };
    }

    const message = err.response?.data.message;

    console.error("Error saving queue:", err);
    toast.error(`Erro ao salvar na fila: ${message || "Tente novamente mais tarde."}`);

    const error = {
      status: 1,
      message1: "",
      message2: "",
      message3: ""
    };
    const defaultData = {
      data: null,
      isSuccess: false,
      isError: true,
      error: error
    };

    if (message?.search("Você") !== -1) {
      error.message1 = message?.slice(0, 50);
      error.message2 = message?.slice(50, 80);
      error.message3 = message?.slice(80, message?.length);

      options?.onError?.(error);
      return defaultData;
    }
    error.message1 = message;
    error.message2 = message.slice(0, 0);
    error.message3 = message.slice(0, 0);

    options?.onError?.(error);
    return defaultData;
  } finally {
    options?.onFinally?.();
    console.log("Save queue operation completed with Body:", body);
  }
}

async function deleteQueueById(id: number, options?: NextApp.ServiceOptions) {
  options?.onInit?.();
  try {
    await api.delete(`queue/delete/${id}`);
    toast.success("Fila deletada com sucesso.");
    options?.onSuccess?.();
  } catch (_error) {
    if (_error instanceof AxiosError) {
      console.error("Error deleting queue: ", _error);
      toast.error(`Erro ao deletar fila: ${_error.message || "Tente novamente mais tarde."}`);
      options?.onError?.();
    }
  } finally {
    console.log(`Delete queue operation completed for ID: ${id}`);
    options?.onFinally?.();
  }
}

export const queueMutations = {
  saveQueue,
  deleteQueueById
};
